export default service => !!service.default_image;
